import {RunShiftCd} from '../';
import {EnumHelper} from './enum-helper';

export class RunShiftCdHelperEnumHelperClass extends EnumHelper {

  public constructor() {
  	super();
    for ( const obj in RunShiftCd ) {
      this._values.push(RunShiftCd[obj]);
      this._keys.push(obj);
    }
  }

  public toEnum(value: string): RunShiftCd {

    for ( const obj in RunShiftCd ) {
      if (RunShiftCd[obj] === value){
        return RunShiftCd[obj] as RunShiftCd;
      }
    }
  }
}

const RunShiftCdHelper = new RunShiftCdHelperEnumHelperClass();
export default RunShiftCdHelper;
